// extracted by mini-css-extract-plugin
module.exports = {"Section7":"Section7_Section7__Pj60P","Layout1":"Section7_Layout1__vNZIX"};